// eslint-disable-next-line import/no-unused-modules
import endpoints, { formatEndpoint } from '../endpoints';
import { RestManagerWithoutBaseUrl } from '../RestManager';
import { formatKPITrendResponse, handleGetMeasurementTypesConversion } from './timeSeriesApiUoMHelper';
class TimeSeries {

    static getMeasurementTypes(assetId) {
        const endpoint = formatEndpoint(endpoints.timeSeries.MeasurementType, { assetId });
        return RestManagerWithoutBaseUrl
            .get(endpoint)
            .then(handleGetMeasurementTypesConversion);
    }

    static getTrend(componentKPITypes, from, to) {
        const endpoint = formatEndpoint(endpoints.timeSeries.Trend, { from, to });
        return RestManagerWithoutBaseUrl
            .post(endpoint, componentKPITypes)
            .then(formatKPITrendResponse);
    }

    static getCommentsList(payload, from, to) {
        const endpoint = formatEndpoint(endpoints.timeSeries.getCommentsList, { from, to });
        return RestManagerWithoutBaseUrl
            .post(endpoint, payload);
    }

    static createandEditComment(payload) {
        const endpoint = formatEndpoint(endpoints.timeSeries.createandEditComment);
        return RestManagerWithoutBaseUrl
            .put(endpoint, payload);
    }

    static deleteComment(commentId) {
        const endpoint = formatEndpoint(endpoints.timeSeries.deleteComment, { commentId });
        return RestManagerWithoutBaseUrl
            .delete(endpoint);
    }
}
export default TimeSeries;
